import { render, staticRenderFns } from "./homeworkMain.vue?vue&type=template&id=76790be4&scoped=true"
import script from "./homeworkMain.vue?vue&type=script&lang=js"
export * from "./homeworkMain.vue?vue&type=script&lang=js"
import style0 from "./homeworkMain.vue?vue&type=style&index=0&id=76790be4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76790be4",
  null
  
)

export default component.exports